export type ComposerEnterKeyInput = {
  key: string;
  shiftKey: boolean;
  isComposing: boolean;
  nativeIsComposing: boolean;
  nativeKeyCode: number;
};

export function shouldSubmitComposerOnKeyDown({
  key,
  shiftKey,
  isComposing,
  nativeIsComposing,
  nativeKeyCode,
}: ComposerEnterKeyInput) {
  if (key !== 'Enter' || shiftKey) {
    return false;
  }

  if (isComposing || nativeIsComposing || nativeKeyCode === 229) {
    return false;
  }

  return true;
}

export function getComposerPrimaryButtonMode({
  canCancel,
  isSubmitting,
}: {
  canCancel: boolean;
  isSubmitting: boolean;
}) {
  if (canCancel) {
    return 'cancel';
  }

  if (isSubmitting) {
    return 'submitting';
  }

  return 'submit';
}

export function mergeVoiceTranscript(transcript: string, draft: string) {
  const trimmedTranscript = transcript.trim();
  if (!trimmedTranscript) {
    return draft;
  }

  if (!draft) {
    return trimmedTranscript;
  }

  if (/\s$/.test(draft)) {
    return `${draft}${trimmedTranscript}`;
  }

  return `${draft} ${trimmedTranscript}`;
}

export function normalizeVoiceTranscriptionLanguageCode(
  languageIdentifier: string | null | undefined
) {
  const trimmed = languageIdentifier?.trim() ?? '';
  if (!trimmed) {
    return undefined;
  }

  const [primarySubtag] = trimmed.split(/[-_]/);
  const normalized = primarySubtag?.toLowerCase();
  if (!normalized || normalized === 'und') {
    return undefined;
  }

  if (normalized.length < 2 || normalized.length > 3) {
    return undefined;
  }

  if (!/^[a-z]+$/.test(normalized)) {
    return undefined;
  }

  return normalized;
}
